import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Modal, notification, Icon } from "antd";
import ModuloDrawer from "../_Aux/FormModulo";
import AulaDrawer from "../_Aux/FormAula";
import DrawerPresencas from "../_Aux/DrawerPresencas";
import { GeralContext } from "../ContextProvider";
import { GlobalContext } from "../../app/providers/GlobalState";
import BotaoProcurar from "../../Geral/_Aux/BotaoProcurar";
import axios from "axios";
import moment from "moment";

import Modulo from "./Componentes/Modulo";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const accessToken = "1f5b9e8481d9c3b11601cc869681281b";

const headerPost = {
    Accept: "application/vnd.vimeo.*+json;version=3.4",
    Authorization: `bearer ${accessToken}`,
    "Content-Type": "application/json"
};

class Modulos extends Component {
    static contextType = GlobalContext;
    state = {
        cursoid: 0,
        turma: "",
        retomar: {},
        modulo_aberto: "0",
        modulos: [],
        total_conteudos: 0,
        total_conteudos_realizados: 0,
        //DRAWER MODULO
        drawerModuloVisible: false,
        moduloid: 0,
        existeCompetencias: false,
        proximaPosicaoModulo: 1,
        dt_precedencia: "",
        //DRAWEER AULA
        drawerAulaVisible: false,
        aulaid: 0,
        aulaTipo: "",
        subTarefaAssiduidade: false,
        subTarefaSumario: false,
        aulaidlvl2: 0,
        tituloAula: "",
        objetivosAula: "",
        tipoQuestionario: "",
        tipoAvaliacao: "",
        descricaoAula: "",
        ordemAula: "",
        ordemAulalvl2: 0,
        estadosModulo: [],
        inicioModulo: "",
        terminoModulo: "",
        objetivosModulo: "",
        tipoAula: "",
        recursoAula: "",
        duracaoAula: null,
        aulalvl2: false,
        dt_modulo_inicio: "",
        dt_modulo_fim: "",
        //AULA TIPO VIDEO
        video: [],
        videoLista: [],
        video_thumbnail: [],
        transcricaoPT: [],
        transcricaoPTId: 0,
        transcricaoBR: [],
        transcricaoBRId: 0,
        transcricaoEN: [],
        transcricaoENId: 0,
        transcricaoES: [],
        transcricaoESId: 0,
        //AULA TIPO AUDIO
        audio: [],
        audioLista: [],
        //AULA TIPO PDF
        pdf: [],
        pdfLista: [],
        //AULA TIPO DOWNLOAD
        download: [],
        downloadLista: [],
        //AULA TIPO HTML
        paginaHTML: false,
        //setHTML: false,
        resetEditor: false,
        //AULA TIPO QUESTIONARIO OU AVALIACAO
        id_avaliacao: 0,
        tem_avaliacao: false,
        questionario: false,
        questoes: [],
        reset: false,
        timer: false,
        dt_inicioAula: null,
        horAula: "",
        gerar_aleatorio: false,
        permitir_exportar: false,
        atribuir_classificacao: true,
        permissaoAula: 1,
        avaliacao_competencia: false,
        baralhar_questoes: false,
        baralhar_opcoes: false,
        //AULA TIPO LINK
        link: "",
        link_embed: false,
        //AULA TIPO TRABALHO
        enunciado: [],
        enunciadoLista: [],
        dt_entrega_inicoAula: null,
        dt_fimAula: null,
        tipo_trabalhoAula: "",
        numero_elementosAula: 2,
        //AULA TIPO SINCRONO e PRESENCIAL
        horaAula: "",
        horaFimAula: "",
        horaFimAula: "",
        codigoAula: "",
        localAula: "",
        editar: false,
        //DRAWER ADD RECURSOS
        recurosid: 0,
        drawerAddRecursos: false,
        //DRAWER PRESENCIAL
        drawerPresencialVisible: false,
        nomePresencial: "",
        dataPresencial: null,
        horaPresencial: "",
        localPresencial: "",
        //DRAWER PRESENCIAL
        drawerSincronaVisible: false,
        nomeSincrona: "",
        dataSincrona: null,
        horaSincrona: "",
        ////DRAWER PRESENÇAS
        //falta: false,
        //presenca: false,
        //presencas: [],
        //participantes: [],
        //loadingParticipantes: false,
        //PERMISSOES
        loading: false,
        //COPIAR/COLAR
        id_copia: 0,
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //FILTROS
        excluirTodos: false,
        pesquisa: "",
        //DRAWER PRESENÇAS
        folhaPresencasId: 0,
        drawerPresencasVisible: false
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        var cursoId = localStorage.getItem("codigo_curso");

        this.setState({
            cursoid: cursoId,
            turma: this.props.match.params.turma
        });

        this.listarModulos(cursoId);
    }

    handlerChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handlerChangeCheckTimer = event => {
        this.setState({ timer: event.target.checked });
    };

    handlerChangeCheck = event => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handlerChangeSelectTipo = value => {
        this.setState({ tipoAula: value });
    };

    handlerChangeSelectTipoQuestionario = value => {
        this.setState({ tipoQuestionario: value });
    };

    handlerChangeSelectTipoAvaliacao = value => {
        this.setState({ tipoAvaliacao: value });
    };

    handlerChangeSelectTipoTrabalho = value => {
        this.setState({ tipo_trabalhoAula: value });
    };

    handlerChangeRadio = event => {
        this.setState({ permissaoAula: event.target.value });
    };

    handleChangeEditor = value => {
        this.setState({
            recursoAula: value,
            paginaHTML: true
        });
    };

    handlerChangeNumberAula = value => {
        this.setState({ ordemAula: value });
    };

    handleChangeTime = value => {
        this.setState({ duracaoAula: value });
    };

    handleChangeHora = value => {
        this.setState({ horaAula: value });
    };

    handleChangeHoraFim = value => {
        this.setState({ horaFimAula: value });
    };

    handlerChangeNumberRepeticoes = value => {
        this.setState({ nr_repeticoes: value });
    };

    handleChangeDataInicio = date => {
        this.setState({ dt_inicioAula: date });
    };

    handleChangeDataFim = date => {
        this.setState({ dt_fimAula: date });
    };

    handlerChangeNumberNrElementos = value => {
        this.setState({ numero_elementosAula: value });
    };

    //CARREGA E LISTA TODOS OS MODULOS PERTENCENTES AO CURSO E IDENTIFICA A ULTIMA POSIÇÃO NA ORDEM
    listarModulos = cursoid => {
        this.setState({
            loading: true
        });

        axios({
            method: "get",
            url: "/api/gerir-curso-modulo/gerir-listar-modulos",
            params: {
                cursoid: cursoid,
                excluirTodos: this.state.excluirTodos,
                pesquisa: this.state.pesquisa
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    this.context.atualizarState({
                        lista_modulos: response.data
                    });

                    this.setState({
                        modulos: response.data,
                        proximaPosicaoModulo: response.data[response.data.length - 1].ordem + 1,
                        loading: false
                    });
                } else
                    this.setState({
                        loading: false
                    });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    listarModulo = moduloid => {
        axios({
            method: "get",
            url: "/api/gerir-curso-modulo/gerir-listar-modulo",
            params: {
                cursoid: localStorage.getItem("codigo_curso"),
                moduloid
            }
        })
            .then(response => {
                const moduloIndex = this.state.modulos.findIndex(x => x.id === moduloid);
                if (moduloIndex === -1) return;

                const _modulos = [...this.state.modulos];
                _modulos[moduloIndex] = response.data;

                this.setState({ modulos: _modulos });
            })
            .catch(() => {});
    };

    //DRAWER MODULO
    //ATUALIZA LISTA
    atualizar = () => {
        this.listarModulos(this.state.cursoid);
        this.setState({
            drawerModuloVisible: false
        });
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DO MODULO QUE ABRIMOS O DETALHE
    carregarModulo = (moduloid, existeCompetencias) => {
        this.setState({
            moduloid,
            existeCompetencias,
            drawerModuloVisible: true
        });
    };

    //EXCLUI O MODULO
    excluirModulo = moduloid => {
        confirm({
            title: "Pretende excluir esta atividade?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/gerir-curso-modulo/excluir-modulo",
                    params: {
                        moduloid: moduloid
                    }
                })
                    .then(() => {
                        var modulos = this.state.modulos;
                        var moduloIndex = modulos.findIndex(x => x.id === moduloid);
                        modulos.splice(moduloIndex, 1);

                        this.setState({
                            modulos
                        });

                        openNotificationWithIcon("success", "Sucesso", "Atividade excluida!");
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    });
            }
        });
    };

    //ATIVAR/INATIVAR O MODULO
    ativarModulo = (moduloid, ativo) => {
        confirm({
            title: ativo ? "Pretende ocultar esta atividade?" : "Pretende mostrar esta atividade?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/gerir-curso-modulo/ativar-modulo",
                    params: {
                        moduloid
                    }
                })
                    .then(() => {
                        var _modulos = this.state.modulos;
                        var moduloIndex = _modulos.findIndex(x => x.id === moduloid);
                        _modulos[moduloIndex].ativo = !ativo;

                        if (ativo)
                            _modulos[moduloIndex].modulo_Aula.forEach(aula => {
                                aula.ativo = false;
                            });

                        this.setState({
                            modulos: _modulos
                        });

                        if (ativo) openNotificationWithIcon("success", "Sucesso", "Atividade ocultada!");
                    })
                    .catch(() => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível ocultar a atividade!" : "Não foi possível mostrar a atividade!"
                        );
                    });
            }
        });
    };

    //ABRE O DRAWER PARA SE CRIAR UM NOVO MODULO
    onOpenDrawerModulo = () => {
        this.setState({
            drawerModuloVisible: true
        });
    };

    //DRAWER AULA
    //CRIA UMA NOVA AULA
    criarAula = moduloId => {
        this.listarModulo(moduloId);
        this.setState({
            drawerAulaVisible: false
        });
    };

    carregarAula = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                var modulo = this.state.modulos.find(x => x.id === moduloid);
                var tarefaPai = "";
                if (aulalvl2) tarefaPai = modulo.modulo_Aula.find(x => x.id === response.data.id_modulo_aula);

                this.setState({
                    moduloid,
                    //existeCompetencias,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    descricaoAula: response.data.descricao,
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    aulaTipo: aulalvl2 ? tarefaPai.tipo_Recurso.id : "",
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    dt_inicioAula: response.data.dt_inicio ? moment(response.data.dt_inicio) : null,
                    horaAula: response.data.hora ? moment(response.data.hora, "HH:mm") : null,
                    dt_fimAula: response.data.dt_fim ? moment(response.data.dt_fim) : null,
                    drawerAulaVisible: true,
                    reset: true,
                    link: response.data.recurso,
                    link_embed: response.data.link_embed,
                    codigoAula: response.data.recurso,
                    localAula: response.data.recurso,
                    id_avaliacao: response.data.id_avaliacao,
                    tem_avaliacao: response.data.tem_avaliacao,
                    editar: true,
                    aulalvl2,
                    dt_modulo_inicio: modulo.dt_inicio,
                    dt_modulo_fim: modulo.dt_termino
                });
            })
            .catch(() => {});
    };

    carregarAulaVideo = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula-video",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                //var video = [];
                var transcricaoPT = [];
                var transcricaoPTId = 0;
                var transcricaoBR = [];
                var transcricaoBRId = 0;
                var transcricaoEN = [];
                var transcricaoENId = 0;
                var transcricaoES = [];
                var transcricaoESId = 0;

                response.data.modulo_Aula_Linguas.forEach(lingua => {
                    if (lingua.id_lingua === 1 && lingua.transcricao) {
                        transcricaoPT.push({
                            uid: "1",
                            name: lingua.transcricao_nome,
                            status: "done",
                            legendaid: lingua.transcricao
                            //url: lingua.transcricao
                        });
                        transcricaoPTId = lingua.transcricao;
                    }
                    if (lingua.id_lingua === 2 && lingua.transcricao) {
                        transcricaoBR.push({
                            uid: "1",
                            name: lingua.transcricao_nome,
                            status: "done",
                            legendaid: lingua.transcricao
                            //url: lingua.transcricao
                        });
                        transcricaoBRId = lingua.transcricao;
                    }
                    if (lingua.id_lingua === 3 && lingua.transcricao) {
                        transcricaoEN.push({
                            uid: "1",
                            name: lingua.transcricao_nome,
                            status: "done",
                            legendaid: lingua.transcricao
                            //url: lingua.transcricao
                        });
                        transcricaoENId = lingua.transcricao;
                    }
                    if (lingua.id_lingua === 4 && lingua.transcricao) {
                        transcricaoES.push({
                            uid: "1",
                            name: lingua.transcricao_nome,
                            status: "done",
                            legendaid: lingua.transcricao
                            //url: lingua.transcricao
                        });
                        transcricaoESId = lingua.transcricao;
                    }
                });

                //video.push({
                //    uid: "-1",
                //    name: response.data.recurso_nome,
                //    status: "done"
                //    //url: response.data.recurso
                //});

                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recurso: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    video: [],
                    videoLista: [response.data.recurso_nome],
                    transcricaoPT,
                    transcricaoPTId,
                    transcricaoBR,
                    transcricaoBRId,
                    transcricaoEN,
                    transcricaoENId,
                    transcricaoES,
                    transcricaoESId,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaAudio = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    audio: [],
                    audioLista: [response.data.recurso_nome],
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaHtml = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    paginaHTML: true
                });

                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaPdf = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    pdf: [],
                    pdfLista: [response.data.recurso_nome],
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaQuestionario = (moduloid, existeCompetencias, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                var questoes = [];
                var modulo = this.state.modulos.find(x => x.id === moduloid);

                if (response.data.questoes.length > 0)
                    response.data.questoes.forEach(questao => {
                        var opcoes = [];
                        var ficheiro_pergunta = [];
                        var ficheiro_resolucao = [];

                        if (questao.ficheiro_pergunta)
                            ficheiro_pergunta.push({
                                uid: "1",
                                name: questao.ficheiro_nome_pergunta,
                                status: "done",
                                url: questao.ficheiro_pergunta
                            });

                        if (questao.ficheiro_resolucao)
                            ficheiro_resolucao.push({
                                uid: "1",
                                name: questao.ficheiro_nome_resolucao,
                                status: "done",
                                url: questao.ficheiro_resolucao
                            });

                        questao.opcoes.forEach(opcao => {
                            opcoes.push({
                                id: opcao.id,
                                texto: opcao.texto,
                                ordem: opcao.ordem,
                                verdadeiro: opcao.verdadeiro
                            });
                        });

                        if (questao.opcoes.length === 0)
                            if (questao.tipo_pergunta === "Escolha única" || questao.tipo_pergunta === "Escolha múltipla")
                                opcoes.push({
                                    id: 0,
                                    texto: "",
                                    ordem: 1,
                                    verdadeiro: false
                                });

                        questoes.push({
                            id: questao.id,
                            pergunta: questao.pergunta,
                            ficheiro_pergunta: ficheiro_pergunta,
                            tipo_pergunta: questao.tipo_pergunta,
                            ordem: questao.ordem,
                            pontuacao: questao.pontuacao,
                            texto_resolucao: questao.texto_resolucao,
                            ficheiro_resolucao: ficheiro_resolucao,
                            opcoes: opcoes
                        });
                    });
                else
                    questoes.push({
                        id: 0,
                        pergunta: "",
                        ficheiro_pergunta: [],
                        tipo_pergunta: 0,
                        ordem: 1,
                        pontuacao: "",
                        texto_resolucao: "",
                        ficheiro_resolucao: [],
                        opcoes: [
                            {
                                id: 0,
                                texto: "",
                                ordem: 1,
                                verdadeiro: false
                            }
                        ]
                    });

                var _id_tipo_recurso = response.data.id_tipo_recurso;
                var _id_tipo_questionario = 0;
                if (_id_tipo_recurso === 5 || _id_tipo_recurso === 14 || _id_tipo_recurso === 15) {
                    _id_tipo_questionario = _id_tipo_recurso;
                    _id_tipo_recurso = 5;
                }

                //var _id_tipo_avaliacao = 0;
                //if (_id_tipo_recurso === 6 || _id_tipo_recurso === 16) {
                //    _id_tipo_avaliacao = _id_tipo_recurso;
                //    _id_tipo_recurso = 6;
                //}

                this.setState({
                    moduloid,
                    existeCompetencias,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: _id_tipo_recurso,
                    tipoQuestionario: _id_tipo_questionario,
                    tem_avaliacao: response.data.tem_avaliacao,
                    id_avaliacao: response.data.id_avaliacao,
                    //tipoAvaliacao: _id_tipo_avaliacao,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    timer: response.data.timer,
                    dt_inicioAula: response.data.dt_inicio ? moment(response.data.dt_inicio) : null,
                    horaAula: response.data.hora ? moment(response.data.hora, "HH:mm") : null,
                    questionario: response.data.questoes.length > 0 ? true : false,
                    permitir_exportar: response.data.permitir_exportar,
                    atribuir_classificacao: response.data.atribuir_classificacao,
                    avaliacao_competencia: response.data.avaliacao_competencia,
                    questoes,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2,
                    dt_modulo_inicio: modulo.dt_inicio,
                    dt_modulo_fim: modulo.dt_termino,
                    permissaoAula: response.data.permissao,
                    baralhar_questoes: response.data.baralhar_questoes,
                    baralhar_opcoes: response.data.baralhar_opcoes
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaDownload = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    download: [],
                    downloadLista: [response.data.recurso_nome],
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaTrabalho = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                var enunciadoLista = [];
                var modulo = this.state.modulos.find(x => x.id === moduloid);

                if (response.data.id_tipo_recurso === 8 && response.data.recurso) {
                    enunciadoLista = [response.data.recurso_nome];
                }

                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    descricaoAula: response.data.descricao,
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    recursoAula: response.data.recurso,
                    duracaoAula: response.data.duracao ? moment(response.data.duracao, "HH:mm") : null,
                    dt_inicioAula: response.data.dt_inicio ? moment(response.data.dt_inicio) : null,
                    horaAula: response.data.hora ? moment(response.data.hora, "HH:mm") : null,
                    dt_fimAula: response.data.dt_fim ? moment(response.data.dt_fim) : null,
                    tipo_trabalhoAula: response.data.tipo_trabalho,
                    numero_elementosAula: response.data.numero_elementos,
                    avaliacao_competencia: response.data.avaliacao_competencia,
                    enunciado: [],
                    enunciadoLista,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2,
                    dt_modulo_inicio: modulo.dt_inicio,
                    dt_modulo_fim: modulo.dt_termino
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaPasta = (moduloid, aulaid) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula-pasta",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    moduloid,
                    aulaid: aulaid,
                    aulaidlvl2: 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    tipoAula: response.data.id_tipo_recurso,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true
                });
            })
            .catch(() => {});
    };

    //ABRE O DRAWER COM A INFORMAÇÃO DA AULA QUE ABRIMOS O DETALHE
    carregarAulaPresencas = (moduloid, aulaid, aulalvl2) => {
        axios({
            method: "get",
            url: "/api/curso/detalhe-aula-presencas",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                var dados = JSON.parse(response.data.recurso);

                this.setState({
                    moduloid,
                    aulaid: !aulalvl2 ? aulaid : response.data.id_modulo_aula,
                    aulaidlvl2: aulalvl2 ? aulaid : 0,
                    tituloAula: response.data.nome,
                    objetivosAula: response.data.objetivos ? response.data.objetivos : "",
                    ordemAula: response.data.ordem,
                    //dt_inicioAula: response.data.dt_inicio ? moment(response.data.dt_inicio) : null,
                    //horaAula: response.data.hora ? moment(response.data.hora, "HH:mm") : null,
                    //horaFimAula: response.data.hora_fim ? moment(response.data.hora_fim, "HH:mm") : null,
                    tipoAula: response.data.id_tipo_recurso,
                    //presenca: dados.presenca_coletiva,
                    //falta: dados.falta_coletiva,
                    //presencas: dados.presencas,
                    drawerAulaVisible: true,
                    reset: true,
                    editar: true,
                    aulalvl2
                });
            })
            .catch();
    };

    //EXCLUI A AULA
    excluirAula = (moduloIndex, aulaid) => {
        confirm({
            title: "Pretende excluir este conteúdo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/curso-aula/excluir-aula",
                    params: {
                        aulaid: aulaid
                    }
                })
                    .then(() => {
                        //ATUALIZA AS AULAS NO MODULO APOS EXCLUIR
                        var modulo = this.state.modulos[moduloIndex];

                        const aula = modulo.modulo_Aula.find(x => x.id === aulaid);
                        modulo.modulo_Aula = modulo.modulo_Aula.filter(x => x.id !== aulaid);

                        this.setState({
                            modulo
                        });

                        if (aula.tipo_Recurso.id === 6 || aula.tipo_Recurso.id === 8 || aula.tipo_Recurso.id === 11)
                            this.context.atualizarEventosHoje();

                        openNotificationWithIcon("success", "Sucesso", "Conteúdo excluido!");
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                    });
            }
        });
    };

    //EXCLUI A AULA
    excluirVideoVimeo = (moduloIndex, aulaid, videoId) => {
        confirm({
            title: "Pretende excluir esta tarefa?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "get",
                    url: "/api/curso/validar-excluir-vimeo",
                    params: {
                        videoId
                    }
                })
                    .then(response => {
                        if (response.data) this.excluirAula(moduloIndex, aulaid);
                        else
                            axios({
                                method: "delete",
                                url: `https://api.vimeo.com/videos/${videoId}`,
                                headers: headerPost
                            }).then(() => {
                                this.excluirAula(moduloIndex, aulaid);
                            });
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir a tarefa!");
                    });
            }
        });
    };

    //ATIVAR/INATIVAR A AULA
    ativarAula = (moduloId, moduloIndex, aulaid, ativo, pagina_unica) => {
        confirm({
            title: ativo ? "Pretende ocultar esta tarefa?" : "Pretende mostrar esta tarefa?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/curso/ativar-aula",
                    params: {
                        aulaid: aulaid
                    }
                })
                    .then(() => {
                        if (pagina_unica) {
                            this.listarModulo(moduloId);
                        } else {
                            var _modulos = [...this.state.modulos];
                            var aulaIndex = _modulos[moduloIndex].modulo_Aula.findIndex(x => x.id === aulaid);

                            _modulos[moduloIndex].modulo_Aula[aulaIndex].ativo = !ativo;

                            this.setState({
                                modulos: _modulos
                            });
                        }

                        if (ativo) openNotificationWithIcon("success", "Sucesso", "Tarefa ocultada!");
                    })
                    .catch(() => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível ocultar a tarefa!" : "Não foi possível mostrar a tarefa!"
                        );
                    });
            }
        });
    };

    adicionarQuestionarioAvaliacao = () => {
        this.setState({
            questoes: [
                {
                    pergunta: "",
                    ficheiro_pergunta: [],
                    tipo_pergunta: undefined,
                    ordem: 1,
                    texto_resolucao: "",
                    ficheiro_resolucao: [],
                    opcoes: []
                }
            ]
        });
    };

    //GUARDA AS NOVAS RESPOSTAS AO QUESTIONARIO
    alterarQuestionario = questoes => {
        this.setState({
            questionario: questoes.length > 0 ? true : false,
            questoes: questoes
        });
    };

    //GUARDA AS NOVAS RESPOSTAS AO QUESTIONARIO
    alterarAvaliacao = questoes => {
        this.setState({
            questionario: questoes.length > 0 ? true : false,
            questoes: questoes
        });
    };

    //GUARDA AS NOVAS RESPOSTAS AO QUESTIONARIO
    alterarQuestProgresso = questoes => {
        this.setState({
            questionario: questoes.length > 0 ? true : false,
            questoes: questoes
        });
    };

    //ABRE O DRAWER PARA SE CRIAR UMA NOVA AULA
    onOpenDrawerAula = (moduloid, ordemAula, existeCompetencias) => {
        var modulo = this.state.modulos.find(x => x.id === moduloid);

        this.setState({
            moduloid: moduloid,
            existeCompetencias,
            aulaid: 0,
            tituloAula: "",
            objetivosAula: "",
            ordemAula: ordemAula,
            tipoAula: undefined,
            tem_avaliacao: false,
            id_avaliacao: 0,
            subTarefaAssiduidade: false,
            subTarefaSumario: false,
            tipoQuestionario: undefined,
            tipoAvaliacao: undefined,
            descricaoAula: "",
            recursoAula: "",
            duracaoAula: null,
            dt_inicioAula: null,
            dt_fimAula: null,
            aulalvl2: false,
            video: [],
            videoLista: [],
            video_thumbnail: [],
            audio: [],
            audioLista: [],
            transcricaoPT: [],
            transcricaoBR: [],
            transcricaoEN: [],
            transcricaoES: [],
            pdf: [],
            pdfLista: [],
            download: [],
            downloadLista: [],
            paginaHTML: false,
            //setHTML: false,
            resetEditor: true,
            questionario: false,
            questoes: [
                {
                    pergunta: "",
                    ficheiro_pergunta: [],
                    tipo_pergunta: undefined,
                    ordem: 1,
                    pontuacao: "",
                    texto_resolucao: "",
                    ficheiro_resolucao: [],
                    opcoes: []
                }
            ],
            drawerAulaVisible: true,
            enunciado: [],
            enunciadoLista: [],
            dt_entrega_inicoAula: null,
            tipo_trabalhoAula: undefined,
            numero_elementosAula: 2,
            reset: true,
            timer: false,
            link: "",
            link_embed: false,
            horaAula: "",
            horaFimAula: "",
            codigoAula: "",
            localAula: "",
            editar: false,
            permitir_exportar: false,
            avaliacao_competencia: false,
            //atribuir_classificacao: true,
            dt_modulo_inicio: modulo.dt_inicio,
            dt_modulo_fim: modulo.dt_termino,
            permissaoAula: 1,
            baralhar_questoes: false,
            baralhar_opcoes: false
        });
    };

    copiarTarefa = tarefaid => {
        this.context.atualizarState({
            id_copia_tarefa: tarefaid
        });
    };

    stopReset = () => {
        this.setState({
            reset: false
        });
    };

    carregarDataPrecedencia = precedenciaId => {
        if (precedenciaId > 0) {
            var modulo = this.state.modulos.find(x => x.id === precedenciaId);

            this.setState({
                dt_precedencia: modulo.dt_termino ? modulo.dt_termino : modulo.dt_inicio
            });
        } else
            this.setState({
                dt_precedencia: ""
            });
    };

    HandleKeyPress = e => {
        if (e.key === "Enter") {
            this.setState(
                {
                    pesquisa: e.target.value
                },
                () => this.listarModulos(this.state.cursoid)
            );
        }
    };

    resetCaixaProcura = () => {
        this.setState(
            {
                pesquisa: ""
            },
            () => this.listarModulos(this.state.cursoid)
        );
    };

    listarParticipantes = () => {
        this.setState(
            {
                loadingParticipantes: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/curso/presencas-participantes",
                    timeout: 60 * 10 * 1000,
                    params: {
                        cursoid: this.state.cursoid
                    }
                })
                    .then(response => {
                        this.setState({
                            participantes: response.data,
                            loadingParticipantes: false
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 401)
                            this.setState({
                                redirect: true,
                                redirectLink: "/login"
                            });
                    });
            }
        );
    };

    montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));

            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    render() {
        const {
            cursoid,
            turma,
            moduloid,
            proximaPosicaoModulo,
            modulo_aberto,
            modulos,
            //COPIAR/COLAR
            id_copia,
            //REDIRECT
            redirect,
            redirectLink,
            //DRAWER PRESENÇAS
            folhaPresencasId,
            drawerPresencasVisible,
            loading
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const acesso = this.context.acessos?.find(x => x.func === 18);

        return (
            <GeralContext.Consumer>
                {geralContext => {
                    return (
                        <div className="container container-body">
                            <div className="curso-modulos">
                                <div className="controlos controlos-fundo">
                                    <div className="bloco-esquerda">
                                        <div>
                                            {acesso?.create && (
                                                <button
                                                    className="botao-principal botao-principal-redondo"
                                                    title="Nova Atividade"
                                                    disabled={loading}
                                                    onClick={() => this.setState({ moduloid: 0, drawerModuloVisible: true })}
                                                >
                                                    +
                                                </button>
                                            )}
                                        </div>
                                        <div className="controlo-search">
                                            <BotaoProcurar
                                                HandleKeyPress={this.HandleKeyPress}
                                                resetCaixaProcura={this.resetCaixaProcura}
                                                tem_placeholder
                                                placeholder="Procurar nos Participantes"
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                    <div className="bloco-direita">{this.montarBotaoVoltar()}</div>
                                </div>
                                {loading && (
                                    <div className="loading-data">
                                        <div className="loading" />
                                    </div>
                                )}
                                {modulos.map((modulo, index) => (
                                    <Modulo
                                        key={index}
                                        turma={turma}
                                        id_copia={id_copia}
                                        cursoid={cursoid}
                                        index={index}
                                        modulo_aberto={modulo_aberto}
                                        modulo={modulo}
                                        botoesVisiveis
                                        carregarModulo={this.carregarModulo}
                                        excluirModulo={this.excluirModulo}
                                        ativarModulo={this.ativarModulo}
                                        onOpenDrawerAula={this.onOpenDrawerAula}
                                        carregarAula={this.carregarAula}
                                        disabled={!modulo.subItens}
                                        inscrito={!geralContext.inscricao || geralContext.inscrito}
                                        carregarAulaVideo={this.carregarAulaVideo}
                                        carregarAulaAudio={this.carregarAulaAudio}
                                        carregarAulaHtml={this.carregarAulaHtml}
                                        carregarAulaPdf={this.carregarAulaPdf}
                                        carregarAulaQuestionario={this.carregarAulaQuestionario}
                                        carregarAulaDownload={this.carregarAulaDownload}
                                        carregarAulaTrabalho={this.carregarAulaTrabalho}
                                        carregarAulaPasta={this.carregarAulaPasta}
                                        copiarTarefa={this.copiarTarefa}
                                        listarModulo={this.listarModulo}
                                    />
                                ))}
                            </div>
                            <ModuloDrawer
                                cursoid={cursoid}
                                moduloid={moduloid}
                                dt_precedencia={this.state.dt_precedencia}
                                proximaPosicaoModulo={proximaPosicaoModulo}
                                onClose={() => this.setState({ drawerModuloVisible: false })}
                                visible={this.state.drawerModuloVisible}
                                atualizar={this.atualizar}
                                carregarDataPrecedencia={this.carregarDataPrecedencia}
                            />
                            <AulaDrawer
                                {...this.state}
                                tituloAula={this.state.tituloAula}
                                objetivosAula={this.state.objetivosAula}
                                ordem={this.state.ordemAula}
                                tipoAula={this.state.tipoAula}
                                tipoQuestionario={this.state.tipoQuestionario}
                                tipoAvaliacao={this.state.tipoAvaliacao}
                                idAvaliacao={this.state.id_avaliacao}
                                temAvaliacao={this.state.tem_avaliacao}
                                criarAula={this.criarAula}
                                onClose={() =>
                                    this.setState({
                                        drawerAulaVisible: false
                                    })
                                }
                                adicionarQuestionarioAvaliacao={this.adicionarQuestionarioAvaliacao}
                                alterarQuestionario={this.alterarQuestionario}
                                alterarAvaliacao={this.alterarAvaliacao}
                                alterarQuestProgresso={this.alterarQuestProgresso}
                                alterarPaginaHTML={this.alterarPaginaHTML}
                                handlerChange={this.handlerChange}
                                handleChangeEditor={this.handleChangeEditor}
                                handlerChangeNumber={this.handlerChangeNumberAula}
                                handlerChangeNumberRepeticoes={this.handlerChangeNumberRepeticoes}
                                handleChangeTime={this.handleChangeTime}
                                handleChangeHora={this.handleChangeHora}
                                handleChangeHoraFim={this.handleChangeHoraFim}
                                handlerChangeSelectTipo={this.handlerChangeSelectTipo}
                                handlerChangeSelectTipoQuestionario={this.handlerChangeSelectTipoQuestionario}
                                handlerChangeSelectTipoAvaliacao={this.handlerChangeSelectTipoAvaliacao}
                                handlerChangeSelectTipoTrabalho={this.handlerChangeSelectTipoTrabalho}
                                handlerChangeCheckRepeticoes={this.handlerChangeCheckRepeticoes}
                                handlerChangeCheckTimer={this.handlerChangeCheckTimer}
                                handleChangeDataInicio={this.handleChangeDataInicio}
                                handleChangeDataFim={this.handleChangeDataFim}
                                handlerChangeCheck={this.handlerChangeCheck}
                                handlerChangeNumberNrElementos={this.handlerChangeNumberNrElementos}
                                handlerChangeRadio={this.handlerChangeRadio}
                                listarParticipantes={this.listarParticipantes}
                                stopReset={this.stopReset}
                            />
                            <DrawerPresencas
                                onClose={() => this.setState({ drawerPresencasVisible: false })}
                                cursoid={this.state.cursoid}
                                folhaPresencasId={folhaPresencasId}
                                drawerPresencasVisible={drawerPresencasVisible}
                            />
                        </div>
                    );
                }}
            </GeralContext.Consumer>
        );
    }
}

export default Modulos;
